import { render, staticRenderFns } from "./public-feedback.vue?vue&type=template&id=466e0867&"
import script from "./public-feedback.vue?vue&type=script&lang=js&"
export * from "./public-feedback.vue?vue&type=script&lang=js&"
import style0 from "./public-feedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports